import { getTaxonomyByPreferredLocale } from '../../../lib/briefing';
import { Taxonomies, TaxonomyWithKey } from '../../../types/briefing';

export const sortTaxonomiesByName = (
  a: TaxonomyWithKey,
  b: TaxonomyWithKey,
): number =>
  (a.data || '').localeCompare(b.data || '', [], {
    sensitivity: 'base',
  });

export const getAndSortApplicationsWithCorrectLocale = (
  availableTaxonomies: Taxonomies,
  marketAbbreviation: string | undefined,
  userLocale: string,
): TaxonomyWithKey[] =>
  Object.keys(availableTaxonomies)
    .map(
      (key: string): TaxonomyWithKey => ({
        ...getTaxonomyByPreferredLocale(key, availableTaxonomies, userLocale),
        key,
      }),
    )
    .filter(
      // This extracts just the Application taxonomies
      (taxonomy: TaxonomyWithKey) => {
        const match = new RegExp(`^A_${marketAbbreviation}_[0-9]+$`);
        return taxonomy.key.match(match);
      },
    )
    .filter(({ data, locale }) => !!data && !!locale)
    .sort(sortTaxonomiesByName);

export const getMaxApplicationLevel = (
  availableTaxonomies: Taxonomies,
  taxonomyMarketAbbreviaton: string | undefined,
): number =>
  // Hard-code level for Specialty AgriEnvironmental question for @rosaria why?
  taxonomyMarketAbbreviaton === 'AG'
    ? 2
    : Object.keys(availableTaxonomies)
        .filter((taxonomy) =>
          taxonomy.startsWith(`A_${taxonomyMarketAbbreviaton}`),
        )
        .reduce((currentHighestLevel: number, applicationKey: string) => {
          const level = applicationKey.split('_').length - 2;
          if (level > currentHighestLevel) {
            return level;
          }
          return currentHighestLevel;
        }, 0);

export const getApplicationKeysByParentKey = (
  parentKey: string,
  availableTaxonomies: Taxonomies,
): string[] => {
  const regex = new RegExp(`^${parentKey}(_[0-9]{3})$`);
  const otherKeys = [
    'A_PC_005_008',
    'A_PC_014',
    'A_PC_014_001',
    'A_FH_003_004_007',
    'A_FH_005_004_008',
    'A_FH_006_004_008',
    'A_FH_007_004_007',
    'A_FH_008_004_007',
    'A_FH_009_004_006',
    'A_FH_011_004_007',
    'A_FH_012_004_006',
    'A_FH_013_004_005',
  ];
  return Object.keys(availableTaxonomies).filter(
    (tax) => tax.match(regex) && !otherKeys.includes(tax),
  );
};
